const keyboardMatch = (event, { key, code }) => {
    return event.key === key || event.code === code;
};
const keyboardMatches = (event, keysToMatch) => {
    for (let i = 0; i < keysToMatch.length; i++) {
        if (keyboardMatch(event, keysToMatch[i])) {
            return true;
        }
    }
    return false;
};

export { keyboardMatch, keyboardMatches };
//# sourceMappingURL=match.js.map
